import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import {BrowserRouter as Router} from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { ThemeProvider as CustomThemeProvider } from './context/ThemeContext'
import theme from './context/theme'
import './i18n'

ReactDOM.createRoot(document.getElementById('root')).render(
  <Router>
    <AuthProvider>
      <CustomThemeProvider>
        <MuiThemeProvider theme={theme}>
          <React.StrictMode>
            <App />
          </React.StrictMode>
        </MuiThemeProvider>
      </CustomThemeProvider>
    </AuthProvider>
  </Router>
)